import React from 'react';
import { CRow, CCol, CPagination } from '@coreui/react';

interface IDataTablePaginationProps {
  page: number;
  totalEntries: number;
  itemsPerPage: number;
  onChange: (page: number) => void;
}

export const DataTablePagination: React.FunctionComponent<IDataTablePaginationProps> = ({
  page, onChange, totalEntries, itemsPerPage, ...props
}) => {
  const fromIndex = (page - 1) * itemsPerPage;
  const toIndex = totalEntries < fromIndex + itemsPerPage ? totalEntries : fromIndex + itemsPerPage;
  const totalPages = Math.ceil(totalEntries / itemsPerPage);
  return (
    <CRow>
      {totalEntries > 0 && (
        <CCol className="d-flex align-items-center">
          <span>Showing {fromIndex + 1} through {toIndex} of {totalEntries} entries</span>
        </CCol>
      )}
      <CCol>
        <CPagination
          {...props}
          style={{ display: totalPages > 1 ? 'inline' : 'none' }}
          onActivePageChange={(page: number) => {
            page && onChange(page);
          }}
          pages={totalPages}
          activePage={page}
          addListClass="mb-0"
          align="end"
        />
      </CCol>
    </CRow>
  );
}
